import { styled } from '@mui/material';
import { default as MUITooltip, TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { COLORS } from '../../theme';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUITooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLORS.gray[1200],
    boxShadow: theme.shadows[1],
    fontSize: 12,
    color: `${COLORS.gray[50]} !important`,
    padding: '1em',
    borderRadius: '8px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLORS.gray[1200],
  },
}));

export default Tooltip;
